import React, { useMemo, useRef, useState } from "react"
import { StyleSheet, Text, View } from "react-native"
import * as Animatable from "react-native-animatable"
import InputScrollView from "react-native-input-scroll-view"
import { useDispatch } from "react-redux"
import { useMediaQuery } from "react-responsive"

import Base, { Actions, Auth, Firebase } from "../../../base"
import { Alert, AppButton } from "../../common"
import LoginTextField from "./LoginTextField"

export default function LoginScreen(props) {
  const defaultFields = {
    username: { title: "Username", placeholder: "Username" },
    password: { title: "Password", placeholder: "Password" },
  }
  const [loading, setLoading] = useState(false)
  const [fields, setFields] = useState(defaultFields)
  const isMobile = useMediaQuery(Base.constants.mobile)
  const dispatch = useDispatch()
  var view = useRef()
  var passwordField = useRef()

  props.navigation.setOptions(Base.constants.headerOptions(true))

  function saveCredentials(creds) {
    view.current
      .animate({ 0: { opacity: 1 }, 1: { opacity: 0 } }, 200)
      .then(endState => {
        dispatch(Actions.setCredentials(creds))
      })
  }

  function validate() {
    let valid = true
    let newFields = { ...fields }

    const username = newFields.username.value
    if (!username || username.length === 0) {
      newFields.username.error = "Username is missing"
      valid = false
    }

    const password = newFields.password.value
    if (!password || password.length === 0) {
      newFields.password.error = "Password is missing"
      valid = false
    }
    setFields(newFields)
    return valid
  }

  async function loginTouched() {
    if (!validate()) {
      return
    }
    setLoading(true)

    const { creds, success, error } =
      (await Auth.login(fields.username.value, fields.password.value)) || {}
    if (success && creds) {
      Firebase.logEvent("login")
      saveCredentials(creds)
    } else {
      let message =
        error?.name === "invalid_grant"
          ? "Unable to login with these details, please try again."
          : "You need to have internet access in order to log in"

      Alert.show("Hold Up", message)
      setLoading(false)
    }
  }

  function tfEdited(i, text) {
    let newFields = { ...fields }
    const keys = Object.keys(fields)
    let field = newFields[keys[i]]
    field.value = text
    setFields(newFields)
  }

  function tfOnFocus(i) {
    let newFields = { ...fields }
    const keys = Object.keys(fields)
    let field = newFields[keys[i]]
    delete field.error
    setFields(newFields)
  }

  const loadingOpacityStyle = useMemo(() => ({ opacity: loading ? 0.5 : 1 }), [
    loading,
  ])

  return (
    <Animatable.View style={styles.main} ref={view}>
      <InputScrollView
        style={styles.scrollview}
        contentContainerStyle={styles.inputScrollContainer}
      >
        <View
          style={[styles.card, loadingOpacityStyle]}
          pointerEvents={loading ? "none" : "auto"}
        >
          <Text style={isMobile ? Base.styles.title_sm : Base.styles.title_md}>
            Log In
          </Text>
          <Text style={[Base.styles.body, styles.subTitle]}>
            Manage your orders, stock levels and more
          </Text>
          <View
            style={loadingOpacityStyle}
            pointerEvents={loading ? "none" : "auto"}
          >
            <LoginTextField
              index={0}
              data={fields.username}
              onChange={tfEdited}
              onFocus={tfOnFocus}
              onSubmit={() => passwordField.current.focus()}
            />
            <LoginTextField
              ref={passwordField}
              index={1}
              data={fields.password}
              onChange={tfEdited}
              onFocus={tfOnFocus}
              secure={true}
              onSubmit={loginTouched}
            />
            <AppButton
              style={styles.button}
              title=" Log in "
              onPress={loginTouched}
              loading={loading}
            />
          </View>
        </View>
      </InputScrollView>
    </Animatable.View>
  )
}

const styles = StyleSheet.create({
  main: {
    flex: 1,
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: Base.colours.appLightGrey,
  },

  card: {
    marginHorizontal: 16,
    maxWidth: 340,
  },

  subTitle: {
    marginTop: 15,
    marginBottom: 25,
  },

  button: {
    alignSelf: "center",
    marginBottom: 30,
    marginTop: 5,
    width: 240,
  },

  scrollview: {
    flex: 1,
    minWidth: "100%",
  },

  inputScrollContainer: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
  },
})
